import { ICONS, type IconName } from '../icons';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  title?: string;
}

/**
 * Renders an inlined Vane SVG icon. The SVG uses `currentColor`, so colour is
 * controlled by the surrounding text colour (Tailwind `text-*`). No emojis.
 */
export function Icon({ name, size = 14, className, title }: IconProps) {
  return (
    <span
      role="img"
      aria-label={title}
      aria-hidden={title ? undefined : true}
      className={className}
      style={{ display: 'inline-flex', width: size, height: size }}
      // SVG constants are static, author-controlled strings (no user input).
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
